<template>
    <div class="homePage" >
        <div class="homeLeft" :class="{'homeLeftCollapse': isCollapse}">
            <div class="homeLeftTop">
                <img src="@/assets/img/logo-text.png" alt="">
            </div>
            <el-menu :collapse="isCollapse" :default-active="activeIndex" class="menu_nav" @select="handleSelect">
                <el-menu-item-group class="menu-group" >
                    <el-submenu class="menu-group-sub-menu" index="1" popper-class="menu-sub-popper">
                        <template slot="title">
                            <i class="el-icon-files"></i>
                            <span>内容工具</span>
                        </template>
                        <el-menu-item class="menu-group-item" index="question">调查问卷</el-menu-item>
                        <el-menu-item class="menu-group-item" index="signList">报名表单</el-menu-item>
                        <el-menu-item class="menu-group-item" index="recruitManage">招聘岗位</el-menu-item>
                    </el-submenu>
                </el-menu-item-group>
            </el-menu>
        </div>
        <div class="homeRight">
            <router-view class="homeRightPage"></router-view>
        </div>
    </div>
</template>

<script>
export default {
    name: 'home',
    data() {
        return {
            isCollapse: false,
        }
    },
    computed: {
        activeIndex() {
            return this.$route.meta.parent || this.$route.name;
        }
    },
    mounted() {
        this.resizeEvent();
    },
    methods: {
        handleSelect(index) {
            this.$router.push({name: index});
        },
        resizeEvent() {
			this.resizeMenu();
			window.onresize = this.resizeMenu;
		},
        // 重绘菜单
		resizeMenu() {
			const w = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
			// this.isCollapse = w <= 1490;
		},
    }
}
</script>

<style lang="less">
.homePage {
    height: 100vh;
    display: flex;
    overflow: hidden;
    .homeLeft {
        width: 230px;
        height: 100%;
        border-right: 1px solid #dcdfe6;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        &.homeLeftCollapse {
            width: 78px;
        }
    }
    .el-menu {
        border: none;
    }
    .homeLeftTop {
        height: 78px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-bottom: 1px solid #dcdfe6;
        img {
            max-height: 60%;
        }
    }

    .homeRight {
        flex: 1;
        height: 100%;
        overflow: hidden;
        .homeRightPage {
            height: 100%;
            display: flex;
            flex-direction: column;
            .homeRightContent {
                box-sizing: border-box;
                padding: 16px 24px;
                flex: 1;
                overflow: auto;
            }
        }
    }
}
// 下方使用了大量的important， 因为组件默认的样式要么是直接行内样式，要么就是加了important，没办法，只能这么写
// 使用important仅存于当前类名，不会造成后续的样式污染，不过修改这里的时候，请注意important相关样式修改是否生效
.menu_nav {
	//ie滚动条
	-ms-scroll-chaining: chained;

	-ms-content-zooming: zoom;
	-ms-scroll-rails: none;
	-ms-content-zoom-limit-min: 100%;
	-ms-content-zoom-limit-max: 500%;
	-ms-scroll-snap-type: proximity;
	-ms-scroll-snap-points-x: snapList(100%, 200%, 300%, 400%, 500%);
	-ms-overflow-style: none;
	width: 230px;
	height: 100%;
	flex-shrink: 0;
	overflow-y: auto;
	overflow-x: hidden;
	background-color: #1a203a;
	box-sizing: border-box;
	padding: 0 8px 16px;
	display: flex;
	flex-flow: column nowrap;
	z-index: 11;
	&::-webkit-scrollbar {
		display: none;
	}
	.nav_grow {
		flex-grow: 1;
	}
	.menu-group-title {
		padding: 13px 0 5px;
		color: #ffffff;
	}
	.menu_icon_img {
		width: 100%;
	}
	.unread_tip {
		position: absolute;
		content: '';
		top: 15px;
		right: 15px;
		width: 8px;
		height: 8px;
		border-radius: 50%;
		background-color: rgb(255, 79, 69);
	}
	.menu-group-item {
		position: relative;
        padding-left: 49px !important;
		height: 40px;
		line-height: 40px;
		padding: 0 12px;
		border-radius: 4px;
		color: #ffffff;
		flex-shrink: 0;
		&.is-active {
			background-color: rgba(137, 149, 251, 0.12);
			&::before {
				content: '';
				position: absolute;
				top: 50%;
				left: 0;
				transform: translateY(-50%);
				width: 3px;
				height: 16px;
				background-image: linear-gradient(180deg, #2daeff 0%, #165dff 100%);
				border-radius: 0 2px 2px 0;
			}
		}
		&.is-disabled {
			cursor: pointer;
			opacity: 1;
			&:hover {
				background-color: rgba(137, 149, 251, 0.12) !important;
			}
		}
		&:not(.is-active):hover {
			background-color: rgba(137, 149, 251, 0.12);
		}
		&.menu-group-line {
			margin-top: 17px;
		}
		&.buy_btn {
			padding-left: 20px;
			margin-top: 8px;
			cursor: pointer;
		}
		& + .menu-group-item,
		& + .menu-group-sub-menu {
			margin-top: 8px;
		}
	}
	.menu-group-sub-menu {
		flex-shrink: 0;
		.el-menu {
			background-color: transparent;
			.menu_item {
				.menu_icon {
					display: none;
				}
				.title {
					padding-left: 9px;
				}
				.menu_icon_arrow {
					display: none;
				}
			}
		}
		.el-submenu__icon-arrow {
			// display: none;
		}
		&.is-disabled {
			cursor: inherit;
			opacity: 1;
		}
		.el-submenu__title {
			position: relative;
			height: 40px;
            line-height: 40px;
			padding: 0 12px;
			border-radius: 4px;
			color: #ffffff;
			&:hover {
				background-color: rgba(137, 149, 251, 0.12);
			}
		}
		&:not(.is-opened).is-active {
			.el-submenu__title {
				background-color: rgba(137, 149, 251, 0.12);
				&::before {
					content: '';
					position: absolute;
					top: 50%;
					left: 0;
					transform: translateY(-50%);
					width: 3px;
					height: 16px;
					background-image: linear-gradient(180deg, #2daeff 0%, #165dff 100%);
					border-radius: 0 2px 2px 0;
				}
			}
		}
		&.menu-group-line {
			margin-top: 17px;
		}
		.menu_icon_arrow {
			display: block;
		}
		&.is-opened {
			.menu_icon_arrow {
				transform: rotate(90deg);
			}
		}
		& + .menu-group-item,
		& + .menu-group-sub-menu {
			margin-top: 8px;
		}
	}
	.menu-group-line {
		&::after {
			content: '';
			position: absolute;
			left: 0;
			top: -9px;
			width: 100%;
			height: 1px;
			background-color: #242b4a;
		}
	}
	&.white_nav {
		background-color: #ffffff;
		padding: 0;
		.el-menu-item-group__title {
			margin-top: 10px;
			margin-bottom: 30px;
			width: 100%;
			box-sizing: border-box;
			height: 50px;
			&:hover {
				background-color: #e7f4ff;
				.back_btn {
					color: #2c7dfa;
				}
			}
		}
		.menu-group-line {
			margin-top: 0;
			&::after {
				top: -1px;
				background-color: #e9ecf2;
			}
		}
		.menu-group-item {
			&.buy_btn {
				display: none;
			}
			& + .menu-group-item,
			& + .menu-group-sub-menu {
				margin-top: 0;
			}
		}
		.menu-group-sub-menu {
			& + .menu-group-item,
			& + .menu-group-sub-menu {
				margin-top: 0;
			}
		}
		.menu-group-item,
		.menu-group-sub-menu .menu-group-title {
			height: 46px;
			color: #9098a8;
			font-weight: 500;
			padding-left: 20px !important;

			.el-submenu__icon-arrow {
				display: none;
			}

			.menu_icon_arrow {
				display: none;
			}
		}
		.menu-group-item:hover,
		.menu-group-sub-menu:hover .menu-group-title {
			background-color: #e7f4ff;
			color: #2c7dfa;
		}
		.menu-group-item.is-disabled:hover,
		.menu-group-sub-menu.is-disabled:hover .menu-group-title {
			background-color: #e7f4ff !important;
		}
		.menu-group-item.is-active,
		.menu-group-sub-menu.is-active .menu-group-title {
			background-color: #e7f4ff;
			color: #2c7dfa;
			&::before {
				width: 3px;
				height: 38px;
				background-color: #1191ff;
			}
		}
		.menu_item {
			padding-left: 8px;
			.menu_icon {
				width: 20px;
				margin-right: 25px;
			}
			.icon {
				font-size: 20px;
			}
			.menu_icon_arrow {
				display: none;
			}
		}
		.back_btn {
			padding-left: 8px;
			width: 100%;
			height: 100%;
			color: #9098a8;
			display: flex;
			flex-flow: row nowrap;
			align-items: center;
			justify-content: flex-start;
			cursor: pointer;
			.top_icon {
				width: 20px;
				margin-right: 25px;
				font-size: 18px;
			}
			.back_btn_text {
				font-size: 16px;
				font-weight: 500;
			}
		}
	}
}
// @media (max-width: 1490px) {
// 	.menu_nav {
// 		width: 80px;
// 		padding: 24px 8px 16px;
// 		border: 0;
// 		&::-webkit-scrollbar {
// 			display: none;
// 		}
// 		.el-menu-item-group__title {
// 			display: none;
// 		}
// 		.menu-group-sub-menu {
// 			.el-submenu__title {
// 				height: 64px;
// 				box-sizing: border-box;
// 				border-radius: 8px;
// 				padding: 0 !important;
// 				&:hover {
// 					.menu_item {
// 						opacity: 1;
// 					}
// 				}
// 			}
// 			.menu_icon_arrow {
// 				display: none;
// 			}
// 			.el-submenu__icon-arrow {
// 				right: 5px;
// 				line-height: 1;
// 				display: flex;
// 				justify-content: center;
// 				align-items: center;
// 				display: none;
// 			}
// 			&.item-line {
// 				&:after {
// 					width: 50px;
// 				}
// 			}
// 			&.is-opened.is-active {
// 				&:before {
// 					display: block;
// 				}
// 				.menu_item {
// 					opacity: 1;
// 				}
// 			}
// 			&.is-active {
// 				.el-submenu__title {
// 					background-color: rgba(137, 149, 251, 0.12);
// 					&::before {
// 						display: none;
// 					}
// 				}
// 				.menu_item {
// 					opacity: 1;
// 				}
// 			}
// 			& + .menu-group-item,
// 			& + .menu-group-sub-menu {
// 				margin-top: 10px;
// 			}
// 			&.menu-group-line {
// 				margin-top: 21px;
// 			}
// 		}
// 		.menu-group-item {
// 			padding: 0 !important;
// 			height: 64px;
// 			padding: 0;
// 			border-radius: 8px;
// 			&.is-active {
// 				background-color: rgba(137, 149, 251, 0.12);
// 				&::before {
// 					display: none;
// 				}
// 				.menu_item {
// 					opacity: 1;
// 				}
// 			}
// 			&:hover {
// 				background-color: rgba(137, 149, 251, 0.12);
// 				.menu_item {
// 					opacity: 1;
// 				}
// 			}
// 			& + .menu-group-item,
// 			& + .menu-group-sub-menu {
// 				margin-top: 10px;
// 			}
// 			&.menu-group-line {
// 				margin-top: 21px;
// 			}
// 			&.buy_btn {
// 				margin-top: 10px;
// 			}
// 		}
// 		.menu_item {
// 			opacity: 0.6;
// 			.version_tag {
// 				position: absolute;
// 				width: 20px;
// 				height: auto;
// 				overflow: hidden;
// 				right: 0;
// 				top: 0;
// 				transform: scale(0.6);
// 				padding: 2px 4px;
// 				line-height: 1;
// 			}
// 		}
// 		.menu-group-line {
// 			&::after {
// 				top: -11px;
// 			}
// 		}
// 		&.white_nav {
// 			padding: 0;
// 			.menu_item {
// 				opacity: 1;
// 				padding: 0;
// 				.menu_icon {
// 					margin: 0;
// 				}
// 			}
// 			.el-menu-item-group__title {
// 				display: block;
// 				margin: 0;
// 				padding: 0 !important;
// 				width: 100%;
// 				height: 50px;
// 				display: flex;
// 				justify-content: center;
// 				align-items: center;
// 				.back_btn {
// 					padding-left: 0;
// 				}
// 			}
// 			.back_btn {
// 				justify-content: center;
// 				.top_icon {
// 					margin: 0;
// 					width: auto;
// 					height: auto;
// 					font-size: 20px;
// 				}
// 				.back_btn_text {
// 					display: none;
// 				}
// 			}
// 			.menu-group-item {
// 				padding: 0 !important;
// 				width: 100%;
// 				height: 70px;
// 				border-radius: 0;
// 				& + .menu-group-item,
// 				& + .menu-group-sub-menu {
// 					margin-top: 0;
// 				}
// 			}
// 			.menu-group-sub-menu {
// 				padding: 0 !important;
// 				width: 100%;
// 				height: 70px;
// 				border-radius: 0;
// 				& + .menu-group-item,
// 				& + .menu-group-sub-menu {
// 					margin-top: 0;
// 				}
// 			}
// 		}
// 	}
// }
// 应用于子菜单小窗弹出的样式
.menu-sub-popper {
	.el-menu--popup {
		min-width: 160px;
		padding: 8px;
		transform: translateX(10px);
		background-color: #1a203a;
		border-radius: 8px;
		box-sizing: border-box;
	}
	.menu-group-item {
		height: 36px;
		padding: 0 15px !important;
		border: 4px;
		box-sizing: border-box;
		color: #ffffff;
		&.is-active,
		&:hover {
			background-color: rgba(137, 149, 251, 0.12);
		}
		& + .menu-group-item {
			margin-top: 8px;
		}
		&.is-disabled {
			opacity: 1;
			cursor: pointer;
		}
	}
	.menu_icon {
		display: none;
	}
	.menu_item {
		flex-direction: row;
		align-items: center;
		justify-content: flex-start;
		.title {
			margin-top: 0;
		}
	}
}
</style>
